export const paidPostCSVColumn = {
    key: 'isPaid',
    label: 'Paid',
    accessor: (item) => {
        if (item.is_ad == 1 && item.partner_hashtag)
            return 'Paid Partnership + Brand Partner';
        if (item.is_ad == 1) return 'Paid Partnership';
        if (item.partner_hashtag) return 'Brand Partner';
        return '';
    },
};

export const shopPostCSVColumn = {
    key: 'isShop',
    label: 'TikTok Shop',
    accessor: (item) => (item.isShop ? 'TikTok Shop' : ''),
};
